import { render, staticRenderFns } from "./RemaxToolbar.vue?vue&type=template&id=c6024916&scoped=true&"
import script from "./RemaxToolbar.vue?vue&type=script&lang=ts&"
export * from "./RemaxToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./RemaxToolbar.vue?vue&type=style&index=0&id=c6024916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6024916",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QSpace} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QSpace})
